import AppRouter from './routes/AppRouter';
// import * as Sentry from "@sentry/react";

const App = () => {
  return <AppRouter />;
};


/* hola */
export default App;